import { CustomFilterField, CustomFilterType, CustomFilterOperator } from "../Models/CustomFilterModels";

export enum TaskFilter {
    All,
    AllOutstanding,
    UnassignedTasks,
    AssignedTasks,
    CompletedTasksAwaitingSignOff,
    RejectedTasks,
    PoolTasks,
    CompletedTaskAwaitingInspection,
    AdoptAPathTasks,
    OrphanTasks,
    UnassignedRepeatTasks,
    AssignedRepeatTasks
}

export enum TaskGroupFilter {
    All,
    AllOutstanding,
    CompletedLastMonth,
    UnassignedGroupTasks,
    AssignedGroupTasks,
    CompletedTaskGroupsAwaitingSignOff,
    RejectedTaskGroups,
    CompletedTaskGroupsAwaitingInspection,
    AllOrderedByPriority,
    AllOrderedByCreateDate,
    HighPriorityOrderedByCreateDate,
    MediumPriorityOrderedByCreateDate,
    LowPriorityOrderedByCreateDate
}

export enum TaskOrder {
    None,
    ID,
    Type,
    Status,
    Priority,
    CreateDate,
    TargetDate
}

export enum TaskGroupOrder {
    None,
    ID,
    Type,
    Status,
    Priority
}
